export default function getBreadcrumbsSchema(elementList) {
  const { menuItems } = elementList[0];

  const pathname = elementList[0].url;

  const slicedPathname = pathname;

  const getBreadCrumbsToRender = () => {
    const slicedPathname = pathname;
    const pathnameArray = slicedPathname.split('/');

    let breadcrumbsArrObj = [];

    pathnameArray.forEach((subPath, indexSubPath) => {
      let pathFindedInMenuItems = false;
      menuItems.forEach(mItem => {
        if (mItem?.page?.path === subPath) {
          breadcrumbsArrObj.push({ label: mItem.name, path: mItem.page.path });
          pathFindedInMenuItems = true;
          return;
        }

        // find path is in second menu level
        mItem?.subItems?.forEach(subMenuItem => {
          if (subMenuItem?.page?.path === subPath) {
            breadcrumbsArrObj.push({ label: mItem.name, path: mItem.page.path });
            pathFindedInMenuItems = true;
          }
        });
      });

      // if is last subPath and isn't find in menu -> create last element in breadcrumbsArrObj based on pageTitle prop
      if (indexSubPath === pathnameArray?.length - 1 && !pathFindedInMenuItems) {
        breadcrumbsArrObj.push({ label: elementList[0].name, path: slicedPathname });
      }
    });

    return breadcrumbsArrObj;
  };

  let bread = [
    {
      '@context': 'https://schema.org',
      '@type': 'ListItem',
      position: 1,
      item: {
        '@id': 'https://www.tassomutuo.it/cerca-mutuo',
        name: 'cerca mutuo su tassomutuo.it',
        url: 'https://www.tassomutuo.it/cerca-mutuo',
        description:
          'Confronta e risparmia sul mutuo online con TassoMutuo. Un Consulente ti affiancherà per tutto il percorso. Confronta le rate per la casa: al resto pensiamo noi.', // CHIEDI AD ANDREA
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'ListItem',
      position: 2,
      item: {
        '@id': 'https://www.tassomutuo.it',
        name: 'tassomutuo.it',
        url: 'https://www.tassomutuo.it',
        description:
          'Confronta e risparmia sul mutuo online con TassoMutuo. Un Consulente ti affiancherà per tutto il percorso. Confronta le rate per la casa: al resto pensiamo noi.',
      },
    },
  ];

  bread = [...bread].concat(
    getBreadCrumbsToRender()?.map((bread, index) => {
      return {
        '@context': 'https://schema.org',
        '@type': 'ListItem',
        position: index + 3,
        item: {
          '@id': `https://www.tassomutuo.it/${bread.path.replaceAll('https://www.tassomutuo.it/', '')}`,
          name: bread.label,
          url: `https://www.tassomutuo.it/${bread.path.replaceAll('https://www.tassomutuo.it/', '')}`,
        },
      };
    }),
  );

  // console.log(getBreadCrumbsToRender);

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: bread,
  };

  return schema;
}
